export function isLayerSwitcherGroupProps(item) {
    return !!item.groupId;
}
export function isLayerSwitcherLayerProps(item) {
    return !!item.layerId;
}
//# sourceMappingURL=index.js.map